import { render } from "./ProfileCorporate.vue?vue&type=template&id=29fb89b5&scoped=true"
import script from "./ProfileCorporate.vue?vue&type=script&lang=js"
export * from "./ProfileCorporate.vue?vue&type=script&lang=js"

import "./custom-profile-corporate.scss?vue&type=style&index=0&id=29fb89b5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fb89b5"]])

export default __exports__